"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9019],{

/***/ 72712:
/***/ (function(module) {


var DeviceTypes = {
    DESKTOP: "DESKTOP",
    MOBILE: "MOBILE"
};
module.exports = {
    DeviceTypes: DeviceTypes
};


/***/ }),

/***/ 77162:
/***/ (function(module) {


var INTERNAL_SERVER_ERROR_CODE = 500;
var PAGE_NOT_FOUND_ERROR_CODE = 404;
var FORBIDDEN_ERROR_CODE = 403;
var SUCCESS_CODE = 200;
module.exports = {
    SUCCESS_CODE: SUCCESS_CODE,
    INTERNAL_SERVER_ERROR_CODE: INTERNAL_SERVER_ERROR_CODE,
    PAGE_NOT_FOUND_ERROR_CODE: PAGE_NOT_FOUND_ERROR_CODE,
    FORBIDDEN_ERROR_CODE: FORBIDDEN_ERROR_CODE
};


/***/ }),

/***/ 44553:
/***/ (function(module) {


var TranslationStatus = {
    QUEUED: "QUEUED",
    IN_PROGRESS: "IN_PROGRESS",
    AWAITING_REVIEW: "AWAITING_REVIEW",
    DONE: "DONE"
};
var TranslationStrategy = {
    FULL_TRANSLATION: "FULL_TRANSLATION",
    UPDATE_EXISTING: "UPDATE_EXISTING"
};
var FULL_TRANSLATION_WARNING = "This will create a new localized page draft and ignore any current live localized pages";
var UPDATE_EXISTING_WARNING = "This will update the existing localized pages (if exists) and only add new segments to it";
var strategiesData = [
    {
        id: TranslationStrategy.FULL_TRANSLATION,
        label: "Full translation",
        warningText: FULL_TRANSLATION_WARNING
    },
    {
        id: TranslationStrategy.UPDATE_EXISTING,
        label: "Update existing",
        warningText: UPDATE_EXISTING_WARNING
    }
];
module.exports = {
    TranslationStatus: TranslationStatus,
    TranslationStrategy: TranslationStrategy,
    strategiesData: strategiesData
};


/***/ }),

/***/ 49019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ BaseTemplatePage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./services/templates-generator/api-service.js
var api_service = __webpack_require__(90215);
// EXTERNAL MODULE: ./node_modules/next/error.js
var error = __webpack_require__(12918);
// EXTERNAL MODULE: ./server/services/request-service/request-service.js
var request_service = __webpack_require__(8095);
// EXTERNAL MODULE: ./server/services/aws-service/browser-service.js
var browser_service = __webpack_require__(42057);
// EXTERNAL MODULE: ./services/new-ab-tests/new-ab-tests-service.js
var new_ab_tests_service = __webpack_require__(41871);
// EXTERNAL MODULE: ./constants/headers.js
var headers = __webpack_require__(15675);
// EXTERNAL MODULE: ./constants/cookies.js
var constants_cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./services/pricing/pricing-model/services.js + 2 modules
var services = __webpack_require__(3223);
;// CONCATENATED MODULE: ./services/cookies/granted-feature-cookie-service.js

var getGrantedFeatures = function(cookies) {
    var cookieValue = cookies && cookies[constants_cookies.GRANTED_FEATURE_COOKIE];
    return cookieValue && cookieValue.split(",");
};
var isFeatureGranted = function(features, feature) {
    return features && features.includes(feature);
};

// EXTERNAL MODULE: ./services/query-params-service.js
var query_params_service = __webpack_require__(48965);
// EXTERNAL MODULE: ./constants/query-params.js
var query_params = __webpack_require__(54224);
// EXTERNAL MODULE: ./services/localization/localization-service.js
var localization_service = __webpack_require__(99952);
// EXTERNAL MODULE: ./services/clusters-service.js + 1 modules
var clusters_service = __webpack_require__(25866);
// EXTERNAL MODULE: ./services/pricing/pricing-model/student-service.js
var student_service = __webpack_require__(61418);
// EXTERNAL MODULE: ./constants/status-codes.js
var status_codes = __webpack_require__(77162);
// EXTERNAL MODULE: ./constants/pricing-versions.js
var pricing_versions = __webpack_require__(78803);
// EXTERNAL MODULE: ./server/services/cookies-server-service/cookies-server-service.js
var cookies_server_service = __webpack_require__(79335);
// EXTERNAL MODULE: ./client/services/dynamic-asset-param-service/dynamic-asset-param-service.js
var dynamic_asset_param_service = __webpack_require__(90298);
;// CONCATENATED MODULE: ./services/social-metatags-service.js

var getSocialMetaTagsConfig = function(pageConfig, dynamicAssetParam) {
    var dynamicMetaTagImagesParamPath = pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.dynamicMetaTagImagesParamPath;
    var overrideSocialImagePath = dynamicMetaTagImagesParamPath && dynamicAssetParam && (0,dynamic_asset_param_service/* getImageUrl */.J)(dynamicMetaTagImagesParamPath, dynamicAssetParam);
    var facebookMetaOverride = {
        imagePath: overrideSocialImagePath || (pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.ogImagePath),
        imageWidth: overrideSocialImagePath && (pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.dynamicMetaTagImageWidth),
        imageHeight: overrideSocialImagePath && (pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.dynamicMetaTagImageHeight)
    };
    var twitterMetaOverride = {
        imagePath: overrideSocialImagePath || (pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.twitterImagePath)
    };
    return [
        facebookMetaOverride,
        twitterMetaOverride
    ];
};

// EXTERNAL MODULE: ./services/pricing/pricing-page/pricing-page-config-service.js
var pricing_page_config_service = __webpack_require__(35624);
// EXTERNAL MODULE: ./services/pricing-service.js + 2 modules
var pricing_service = __webpack_require__(15650);
// EXTERNAL MODULE: ./constants/prefetch-constants.js
var prefetch_constants = __webpack_require__(83139);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
;// CONCATENATED MODULE: ./server/signup/api-service.js

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var Sentry = __webpack_require__(48491);
var getCachedData = (__webpack_require__(73645).getCachedData);
var PlatformManifestProvider = (__webpack_require__(54545).PlatformManifestProvider);
var getPlatformManifest = function() {
    var _ref = _async_to_generator(function() {
        var platformManifest, provider, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    platformManifest = {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    provider = new PlatformManifestProvider();
                    return [
                        4,
                        getCachedData(provider)
                    ];
                case 2:
                    platformManifest = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    Sentry.captureException(e);
                    return [
                        2,
                        {
                            success: false
                        }
                    ];
                case 4:
                    return [
                        2,
                        platformManifest
                    ];
            }
        });
    });
    return function getPlatformManifest() {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./server/signup/prefetch-signup-service.js

function prefetch_signup_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function prefetch_signup_service_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                prefetch_signup_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                prefetch_signup_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



function getSignupDynamicAssetsLinks() {
    return _getSignupDynamicAssetsLinks.apply(this, arguments);
}
function _getSignupDynamicAssetsLinks() {
    _getSignupDynamicAssetsLinks = prefetch_signup_service_async_to_generator(function() {
        var platformManifestUrl, signupDynamicAssetsLinks, platformManifestResponse, platformManifest, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    platformManifestUrl = prefetch_constants.PLATFORM_CDN_URL;
                    signupDynamicAssetsLinks = [];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        getPlatformManifest()
                    ];
                case 2:
                    platformManifestResponse = _state.sent();
                    if (platformManifestResponse.response) {
                        platformManifest = platformManifestResponse.response;
                        // manifest dependant assets
                        prefetch_constants.MANIFEST_PREFETCHED_ASSET_KEYS.forEach(function(key) {
                            if (platformManifest[key]) {
                                signupDynamicAssetsLinks.push({
                                    type: prefetch_constants.PREFETCH_TYPES.PREFETCH,
                                    href: platformManifest[key].replace(prefetch_constants.PLATFORM_MANIFEST_ASSETS_CDN_DOMAIN, platformManifestUrl)
                                });
                            }
                        });
                    } else {
                        esm_exports/* captureMessage */.uT("getPlatformManifest() failed. Platform manifest response: ".concat(JSON.stringify(platformManifestResponse)));
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    esm_exports/* captureException */.Tb(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        signupDynamicAssetsLinks
                    ];
            }
        });
    });
    return _getSignupDynamicAssetsLinks.apply(this, arguments);
}

;// CONCATENATED MODULE: ./pages/generated-templates/base-template-page.js






function base_template_page_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function base_template_page_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                base_template_page_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                base_template_page_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}























var getPageConfigResultFromPath = function() {
    var _ref = base_template_page_async_to_generator(function(path, res) {
        var pageConfigResp, errorCode, pageConfigRespJSON, pageConfig;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,api_service/* getPage */.fx)(path)
                    ];
                case 1:
                    pageConfigResp = _state.sent();
                    errorCode = pageConfigResp.statusCode > 200 ? pageConfigResp.statusCode : null;
                    return [
                        4,
                        pageConfigResp.json()
                    ];
                case 2:
                    pageConfigRespJSON = _state.sent();
                    pageConfig = pageConfigRespJSON.pageConfig;
                    if (!pageConfig && !errorCode) {
                        res.statusCode = 404;
                        errorCode = res.statusCode;
                    }
                    return [
                        2,
                        {
                            pageConfig: pageConfig,
                            errorCode: errorCode
                        }
                    ];
            }
        });
    });
    return function getPageConfigResultFromPath(path, res) {
        return _ref.apply(this, arguments);
    };
}();
var BaseTemplatePage = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BaseTemplatePage, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BaseTemplatePage);
    function BaseTemplatePage() {
        (0,_class_call_check/* default */.Z)(this, BaseTemplatePage);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BaseTemplatePage, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var pageConfig = this.props.pageConfig;
                // Track ab test if the landing page is in test.
                if (pageConfig && pageConfig.abTestVariant && pageConfig.abTestName) {
                    BigBrain("track", pageConfig.abTestName, {
                        ab_test: pageConfig.abTestVariant
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var errorCode = this.props.errorCode;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error["default"], {
                    statusCode: errorCode
                });
            }
        }
    ], [
        {
            key: "getInitialProps",
            value: function getInitialProps(param) {
                var req = param.req, res = param.res, asPath = param.asPath;
                return base_template_page_async_to_generator(function() {
                    var handleServerException, path, translations, pageConfig, errorCode, isMobileOrTabletBrowser, isMobileBrowser, isTypeformDisabled, perceptionSurveyTests, forcePricing, forceCurrency, localeToUse, userSelectedLanguage, abTestExactEventName, cloudfrontViewerCountry, hideBannerWithBackground, grantedFeatures, overrideParams, clusterConfig, pageClusterConfig, localizedPages, freeTierForcePrevent, hasStudentPlanCookie, hasStudentPlan, hasFreeTier, generatorSystemConfig, pageConfigResult, abTestVariants, localeId, cookies, ref, clusterId, subClusterId, clusterIdSource, subClusterIdSource, pricingDefaults, pricingVersion, isClusterMiniSitePage, useProductMiniSiteConfig, ignorePageClusterConfig, pageProductId, pageClusterId, pageSubClusterId, dynamicAssetParam, ref1, facebookMetaOverride, twitterMetaOverride, persistantCookies, getPageLocales, activeOriginalPagePath, shouldGetSignupPrefetchedAssets, signupDynamicAssetsLinks, e;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                handleServerException = (__webpack_require__(24730).handleServerException);
                                path = asPath;
                                translations = {};
                                pageConfig = null;
                                errorCode = null;
                                isMobileOrTabletBrowser = null;
                                isMobileBrowser = null;
                                isTypeformDisabled = null;
                                perceptionSurveyTests = null;
                                forcePricing = null;
                                forceCurrency = null;
                                localeToUse = null;
                                userSelectedLanguage = null;
                                abTestExactEventName = null;
                                cloudfrontViewerCountry = "";
                                hideBannerWithBackground = false;
                                grantedFeatures = null;
                                overrideParams = {}; // mind having them in the CDN cache
                                clusterConfig = {};
                                pageClusterConfig = null;
                                localizedPages = [];
                                // req/res is undefined on back/forward navigation in Safari/Firefox.
                                if (!req || !res) {
                                    if (window) {
                                        BigBrain("track", "back_forward_reload_in_mobile", {
                                            kind: "force_reload"
                                        });
                                        window.location.reload();
                                    }
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    12,
                                    ,
                                    14
                                ]);
                                pageConfig = (0,request_service.getPageConfigFromRequest)(req);
                                path = (0,request_service.getPathFromRequest)(req);
                                isMobileOrTabletBrowser = (0,browser_service.isMobileOrTablet)(req);
                                isMobileBrowser = (0,browser_service.isMobile)(req);
                                localeToUse = req.localeToUse;
                                userSelectedLanguage = req.userSelectedLocale;
                                forcePricing = req.query && req.query[query_params.FORCE_PRICING];
                                forceCurrency = req.query && req.query[query_params.FORCE_CURRENCY];
                                hideBannerWithBackground = !!req.cookies[constants_cookies.HIDE_BANNER_WITH_BACKGROUND_COOKIE_NAME];
                                cloudfrontViewerCountry = res.getHeader(headers.CLOUDFRONT_VIEWER_COUNTRY_HEADER);
                                abTestExactEventName = res.getHeader(headers.AB_TEST_EXACT_EVENT_NAME);
                                freeTierForcePrevent = req.query && req.query[query_params.PREVENT_FREE_TIER_PARAM];
                                hasStudentPlanCookie = req.cookies[constants_cookies.HAS_STUDENT_PLAN_INDICATION_COOKIE_NAME];
                                hasStudentPlan = (0,student_service.getHasStudentPlan)({
                                    forcePricing: forcePricing,
                                    hasStudentPlanCookie: hasStudentPlanCookie
                                });
                                hasFreeTier = (0,new_ab_tests_service.getHasFreeTierByRequest)(req);
                                generatorSystemConfig = (0,request_service.getGeneratorSystemConfigOnRequest)(req);
                                isTypeformDisabled = generatorSystemConfig === null || generatorSystemConfig === void 0 ? void 0 : generatorSystemConfig.isTypeformDisabled;
                                perceptionSurveyTests = generatorSystemConfig === null || generatorSystemConfig === void 0 ? void 0 : generatorSystemConfig.perceptionSurveyTests;
                                grantedFeatures = getGrantedFeatures(req.cookies);
                                if (!!pageConfig) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    getPageConfigResultFromPath(path, res)
                                ];
                            case 2:
                                pageConfigResult = _state.sent();
                                pageConfig = pageConfigResult.pageConfig;
                                errorCode = pageConfigResult.errorCode;
                                _state.label = 3;
                            case 3:
                                abTestVariants = (0,new_ab_tests_service.getAllAbTestsVariantsFromRequest)(req);
                                localeId = pageConfig.localeId;
                                return [
                                    4,
                                    (0,localization_service/* getTranslationsFromApi */.Di)(localeId)
                                ];
                            case 4:
                                translations = _state.sent();
                                overrideParams = (0,query_params_service/* getOverrideParams */.Y)(req.query);
                                cookies = req.cookies;
                                ref = (0,clusters_service/* parsePageLoadClusters */.cd)(overrideParams, cookies, pageConfig), clusterId = ref.clusterId, subClusterId = ref.subClusterId, clusterIdSource = ref.clusterIdSource, subClusterIdSource = ref.subClusterIdSource;
                                if (!(pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.fetchClusterConfig)) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    (0,clusters_service/* getClustersConfig */.Is)(clusterId, subClusterId, localeToUse)
                                ];
                            case 5:
                                clusterConfig = _state.sent();
                                _state.label = 6;
                            case 6:
                                pricingDefaults = (0,pricing_page_config_service/* getPricingPageConfig */.g)().pricingDefaults;
                                pricingVersion = (0,services/* getPricingVersion */.rM)({
                                    forcePricing: forcePricing,
                                    cookies: cookies,
                                    abTests: abTestVariants,
                                    currency: (0,pricing_service/* getCurrencyName */.c0)({
                                        forceCurrency: forceCurrency,
                                        pricingDefaults: pricingDefaults,
                                        countryCode: cloudfrontViewerCountry
                                    }),
                                    isV13PricingVersion: pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.isV13PricingVersion
                                });
                                isClusterMiniSitePage = pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.clusterMiniSite;
                                useProductMiniSiteConfig = pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.useProductMiniSiteConfig;
                                ignorePageClusterConfig = pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.ignorePageClusterConfig;
                                pageProductId = pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.pageProductId;
                                pageClusterId = pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.clusterId;
                                pageSubClusterId = pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.subClusterId;
                                if (!(!ignorePageClusterConfig && (!!pageClusterId || !!pageSubClusterId))) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    (0,clusters_service/* getClustersConfig */.Is)(pageClusterId, pageSubClusterId, localeToUse)
                                ];
                            case 7:
                                pageClusterConfig = _state.sent();
                                _state.label = 8;
                            case 8:
                                dynamicAssetParam = req === null || req === void 0 ? void 0 : req.query[query_params.DYNAMIC_ASSET_PARAM];
                                ref1 = (0,_sliced_to_array/* default */.Z)(getSocialMetaTagsConfig(pageConfig, dynamicAssetParam), 2), facebookMetaOverride = ref1[0], twitterMetaOverride = ref1[1];
                                persistantCookies = (0,cookies_server_service.getPersistantServerCookiesFromRequest)(req, res);
                                getPageLocales = (__webpack_require__(91114).getPageLocales);
                                activeOriginalPagePath = req.path; // This is the path the user entered in the browswer, disregarding the ab-test fake redirect we do
                                return [
                                    4,
                                    getPageLocales(activeOriginalPagePath)
                                ];
                            case 9:
                                localizedPages = _state.sent();
                                shouldGetSignupPrefetchedAssets = true;
                                signupDynamicAssetsLinks = [];
                                if (!shouldGetSignupPrefetchedAssets) return [
                                    3,
                                    11
                                ];
                                return [
                                    4,
                                    getSignupDynamicAssetsLinks()
                                ];
                            case 10:
                                signupDynamicAssetsLinks = _state.sent();
                                _state.label = 11;
                            case 11:
                                return [
                                    2,
                                    {
                                        forcePricing: forcePricing,
                                        forceCurrency: forceCurrency,
                                        pageConfig: pageConfig,
                                        asPath: asPath,
                                        errorCode: errorCode,
                                        isMobileOrTabletBrowser: isMobileOrTabletBrowser,
                                        isMobileBrowser: isMobileBrowser,
                                        isTypeformDisabled: isTypeformDisabled,
                                        perceptionSurveyTests: perceptionSurveyTests,
                                        abTestVariants: abTestVariants,
                                        translations: translations,
                                        abTestExactEventName: abTestExactEventName,
                                        cloudfrontViewerCountry: cloudfrontViewerCountry,
                                        pricingVersion: pricingVersion,
                                        hasFreeTier: hasFreeTier,
                                        hasStudentPlan: hasStudentPlan,
                                        localeToUse: localeToUse,
                                        userSelectedLanguage: userSelectedLanguage,
                                        hideBannerWithBackground: hideBannerWithBackground,
                                        grantedFeatures: grantedFeatures,
                                        freeTierForcePrevent: freeTierForcePrevent,
                                        clusterId: clusterId,
                                        subClusterId: subClusterId,
                                        clusterIdSource: clusterIdSource,
                                        subClusterIdSource: subClusterIdSource,
                                        clusterConfig: clusterConfig,
                                        isClusterMiniSitePage: isClusterMiniSitePage,
                                        useProductMiniSiteConfig: useProductMiniSiteConfig,
                                        facebookMetaOverride: facebookMetaOverride,
                                        twitterMetaOverride: twitterMetaOverride,
                                        dynamicAssetParam: dynamicAssetParam,
                                        cookies: cookies,
                                        activePagePath: path,
                                        activeOriginalPagePath: activeOriginalPagePath,
                                        pageClusterConfig: pageClusterConfig,
                                        pageProductId: pageProductId,
                                        pageClusterId: pageClusterId,
                                        pageSubClusterId: pageSubClusterId,
                                        localizedPages: localizedPages,
                                        persistantCookies: persistantCookies,
                                        shouldGetSignupPrefetchedAssets: shouldGetSignupPrefetchedAssets,
                                        signupDynamicAssetsLinks: signupDynamicAssetsLinks
                                    }
                                ];
                            case 12:
                                e = _state.sent();
                                return [
                                    4,
                                    handleServerException({
                                        externalMessage: "Base template's page getInitialProps failed with an exception: ",
                                        e: e,
                                        req: req,
                                        res: res
                                    })
                                ];
                            case 13:
                                _state.sent();
                                res.statusCode = status_codes.INTERNAL_SERVER_ERROR_CODE;
                                return [
                                    2,
                                    {
                                        errorCode: status_codes.INTERNAL_SERVER_ERROR_CODE
                                    }
                                ];
                            case 14:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return BaseTemplatePage;
}(react.PureComponent);



/***/ }),

/***/ 70761:
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(79361)["default"]);
var mongoose = __webpack_require__(46785);
var SchemaKeys = __webpack_require__(4417);
var DeviceTypes = (__webpack_require__(72712).DeviceTypes);
var ENGLISH_LOCALE_ID = (__webpack_require__(72632).ENGLISH_LOCALE_ID);
var PATH_FIELD_NAME = "path";
var LOCALE_FIELD_NAME = "locale";
var DEVICE_FIELD_NAME = "device";
var PUBLISHED_BY_FIELD_NAME = "publishedBy";
var PUBLISHED_AT_FIELD_NAME = "publishedAt";
var PAGE_ID_FIELD_NAME = "pageId";
var PAGE_CONFIG_FIELD_NAME = "pageConfig";
var _obj;
var CurrentPageVersionSchema = new mongoose.Schema((_obj = {}, _defineProperty(_obj, PATH_FIELD_NAME, {
    type: String,
    ref: SchemaKeys.Page,
    unique: true
}), _defineProperty(_obj, LOCALE_FIELD_NAME, {
    type: String,
    default: ENGLISH_LOCALE_ID,
    index: true
}), _defineProperty(_obj, DEVICE_FIELD_NAME, {
    type: String,
    default: DeviceTypes.DESKTOP
}), _defineProperty(_obj, PUBLISHED_BY_FIELD_NAME, {
    type: String
}), _defineProperty(_obj, PUBLISHED_AT_FIELD_NAME, {
    type: Date
}), _defineProperty(_obj, PAGE_ID_FIELD_NAME, {
    type: mongoose.Schema.ObjectId,
    ref: SchemaKeys.Page
}), _defineProperty(_obj, PAGE_CONFIG_FIELD_NAME, mongoose.Schema.Types.Mixed), _obj), {
    timestamps: true,
    minimize: false
});
var CurrentPageVersion = mongoose.models[SchemaKeys.CurrentPageVersion] || mongoose.model(SchemaKeys.CurrentPageVersion, CurrentPageVersionSchema);
module.exports = {
    CurrentPageVersion: CurrentPageVersion,
    PATH_FIELD_NAME: PATH_FIELD_NAME,
    LOCALE_FIELD_NAME: LOCALE_FIELD_NAME,
    DEVICE_FIELD_NAME: DEVICE_FIELD_NAME,
    PUBLISHED_BY_FIELD_NAME: PUBLISHED_BY_FIELD_NAME,
    PUBLISHED_AT_FIELD_NAME: PUBLISHED_AT_FIELD_NAME,
    PAGE_ID_FIELD_NAME: PAGE_ID_FIELD_NAME,
    PAGE_CONFIG_FIELD_NAME: PAGE_CONFIG_FIELD_NAME
};


/***/ }),

/***/ 4417:
/***/ (function(module) {


module.exports = {
    Page: "Page",
    PageConfig: "PageConfig",
    TranslationJob: "TranslationJob",
    CurrentPageVersion: "CurrentPageVersion"
};


/***/ }),

/***/ 2056:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var mongoose = __webpack_require__(46785);
var SchemaKeys = __webpack_require__(4417);
var ref = __webpack_require__(44553), TranslationStatus = ref.TranslationStatus, TranslationStrategy = ref.TranslationStrategy;
var TranslationJobSchema = new mongoose.Schema({
    path: {
        type: String,
        ref: SchemaKeys.Page
    },
    language: {
        type: String
    },
    createdBy: {
        type: String
    },
    translationStrategy: {
        type: String,
        enum: Object.values(TranslationStrategy)
    },
    translationStatus: {
        type: String,
        enum: Object.values(TranslationStatus),
        default: TranslationStatus.QUEUED
    },
    originalConfig: {
        type: mongoose.Schema.ObjectId,
        ref: SchemaKeys.PageConfig
    },
    generatedConfig: {
        type: mongoose.Schema.ObjectId,
        ref: SchemaKeys.PageConfig
    },
    draftConfig: {
        type: mongoose.Schema.ObjectId,
        ref: SchemaKeys.PageConfig
    }
}, {
    timestamps: true
});
var TranslationJob = mongoose.models[SchemaKeys.TranslationJob] || mongoose.model(SchemaKeys.TranslationJob, TranslationJobSchema);
module.exports = TranslationJob;


/***/ }),

/***/ 79335:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var getCookie = (__webpack_require__(47041).getCookie);
var ref = __webpack_require__(13019), WELCOME_BACK_SHOULD_UPDATE_CTA_COOKIE_NAME = ref.WELCOME_BACK_SHOULD_UPDATE_CTA_COOKIE_NAME, WEBSITE_AB_TEST_DEBUG_COOKIE_NAME = ref.WEBSITE_AB_TEST_DEBUG_COOKIE_NAME, PLATFORM_WEBSITE_EXISTING_ACCOUNT_CONTACT_SALES_HEADER_TEST_COOKIE = ref.PLATFORM_WEBSITE_EXISTING_ACCOUNT_CONTACT_SALES_HEADER_TEST_COOKIE, PLATFORM_PRICING_VERSION_COOKIE = ref.PLATFORM_PRICING_VERSION_COOKIE, IS_PAYING_ACCOUNT_COOKIE_NAME = ref.IS_PAYING_ACCOUNT_COOKIE_NAME;
// Cookies in this list MUST be updated in Cloudfront cookie cache definition!!
var PERSISTANT_SERVER_COOKIES = [
    WELCOME_BACK_SHOULD_UPDATE_CTA_COOKIE_NAME,
    WEBSITE_AB_TEST_DEBUG_COOKIE_NAME,
    PLATFORM_PRICING_VERSION_COOKIE,
    IS_PAYING_ACCOUNT_COOKIE_NAME,
    PLATFORM_WEBSITE_EXISTING_ACCOUNT_CONTACT_SALES_HEADER_TEST_COOKIE
];
var getPersistantServerCookiesFromRequest = function(req, res) {
    var cookies = PERSISTANT_SERVER_COOKIES.reduce(function(accu, cookieName) {
        var cookieValue = getCookie(cookieName, {
            req: req,
            res: res
        });
        accu[cookieName] = cookieValue;
        return accu;
    }, {});
    return cookies;
};
module.exports = {
    getPersistantServerCookiesFromRequest: getPersistantServerCookiesFromRequest
};


/***/ }),

/***/ 54545:
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(79658)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7222)/* ["default"] */ .Z);
var _inherits = (__webpack_require__(97788)/* ["default"] */ .Z);
var _interopRequireDefault = (__webpack_require__(92648)/* ["default"] */ .Z);
var _createSuper = (__webpack_require__(37735)/* ["default"] */ .Z);
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
var _bigbrainEventTypes = __webpack_require__(65023);
var _platformLinks = __webpack_require__(16119);
var _prefetchConstants = __webpack_require__(83139);
var _providersKeys = /*#__PURE__*/ _interopRequireDefault(__webpack_require__(15071));
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var BaseDataProvider = (__webpack_require__(73645).BaseDataProvider);
var handleServerException = (__webpack_require__(24730).handleServerException);
var REFRESH_INTERVAL_MINUTES = 30 * 60;
var PlatformManifestProvider = /*#__PURE__*/ function(BaseDataProvider) {
    "use strict";
    _inherits(PlatformManifestProvider, BaseDataProvider);
    var _super = _createSuper(PlatformManifestProvider);
    function PlatformManifestProvider() {
        _classCallCheck(this, PlatformManifestProvider);
        return _super.call(this);
    }
    _createClass(PlatformManifestProvider, [
        {
            key: "key",
            value: function key() {
                return "".concat(_providersKeys.default.MANIFEST_DATA);
            }
        },
        {
            key: "refreshInterval",
            value: function refreshInterval() {
                return REFRESH_INTERVAL_MINUTES;
            }
        },
        {
            key: "getData",
            value: function getData() {
                return _async_to_generator(function() {
                    var options, url, res, response, e;
                    return _tsGenerator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    ,
                                    5
                                ]);
                                options = {
                                    headers: {
                                        "Content-Type": "application/json"
                                    },
                                    method: "GET",
                                    pragma: "no-cache"
                                };
                                url = (0, _platformLinks.getPlatformLinkByEnvironment)(_prefetchConstants.PLATFORM_MANIFEST_ENDPOINT);
                                return [
                                    4,
                                    fetch(url, options)
                                ];
                            case 1:
                                res = _state.sent();
                                if (!((res === null || res === void 0 ? void 0 : res.status) === 200)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    res.json()
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    2,
                                    {
                                        success: true,
                                        response: response
                                    }
                                ];
                            case 3:
                                throw new Error(res.statusText);
                            case 4:
                                e = _state.sent();
                                handleServerException({
                                    e: e,
                                    bbEventParams: {
                                        name: _bigbrainEventTypes.PLATFORM_MANIFEST_FETCH_ERROR,
                                        direct_object: e.message
                                    }
                                });
                                console.error(e.message);
                                throw e;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return PlatformManifestProvider;
}(BaseDataProvider);
module.exports = {
    PlatformManifestProvider: PlatformManifestProvider
};


/***/ }),

/***/ 24730:
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var Sentry = __webpack_require__(48491);
var trackBigBrainEventOnServer = (__webpack_require__(75422).trackBigBrainEventOnServer);
var logException = (__webpack_require__(98989).logException);
var handleServerException = function() {
    var _ref = _async_to_generator(function(param) {
        var externalMessage, e, req, res, extraLogParams, _bbEventParams, bbEventParams;
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    externalMessage = param.externalMessage, e = param.e, req = param.req, res = param.res, extraLogParams = param.extraLogParams, _bbEventParams = param.bbEventParams, bbEventParams = _bbEventParams === void 0 ? {} : _bbEventParams;
                    // 1. log to Coralogix
                    logException({
                        externalMessage: externalMessage,
                        e: e,
                        req: req,
                        res: res,
                        extraLogParams: extraLogParams
                    });
                    // 2. capture exception in Sentry
                    Sentry.captureException(e);
                    return [
                        4,
                        Sentry.flush(2000)
                    ];
                case 1:
                    _state.sent();
                    // 3. track server exception on BigBrain
                    return [
                        4,
                        trackBigBrainEventOnServer(bbEventParams.name || "server_exception", {
                            kind: bbEventParams.kind,
                            placement: req && req.url,
                            info1: e && e.message,
                            info2: req && req.params && req.params.id,
                            directObject: req && req.hostname
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function handleServerException(_) {
        return _ref.apply(this, arguments);
    };
}();
module.exports = {
    handleServerException: handleServerException
};


/***/ }),

/***/ 8095:
/***/ (function(module) {


var getPathFromRequest = function(req) {
    return req.redirectPath || req.path;
};
var getSearchParamsPathFromRequest = function(req) {
    var urlParts = req.url.split("?");
    if (urlParts.length > 1) return urlParts[1];
    else return null;
};
var setRedirectPathOnRequest = function(req, redirectPath) {
    req.redirectPath = redirectPath;
};
var setPageConfigOnRequest = function(req, pageConfig) {
    req.pageConfig = pageConfig;
};
var setGeneratorSystemConfigOnRequest = function(req, config) {
    req.systemConfig = config;
};
var getGeneratorSystemConfigOnRequest = function(req) {
    return req.systemConfig;
};
var getPageConfigFromRequest = function(req) {
    return req.pageConfig;
};
module.exports = {
    getPathFromRequest: getPathFromRequest,
    setRedirectPathOnRequest: setRedirectPathOnRequest,
    setGeneratorSystemConfigOnRequest: setGeneratorSystemConfigOnRequest,
    getGeneratorSystemConfigOnRequest: getGeneratorSystemConfigOnRequest,
    setPageConfigOnRequest: setPageConfigOnRequest,
    getPageConfigFromRequest: getPageConfigFromRequest,
    getSearchParamsPathFromRequest: getSearchParamsPathFromRequest
};


/***/ }),

/***/ 91114:
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _toConsumableArray = (__webpack_require__(53929)/* ["default"] */ .Z);
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var TranslationJob = __webpack_require__(2056);
var normalizePath = (__webpack_require__(32561).normalizePath);
var ref = __webpack_require__(70761), CurrentPageVersion = ref.CurrentPageVersion, PAGE_ID_FIELD_NAME = ref.PAGE_ID_FIELD_NAME;
var initLogger = (__webpack_require__(28879).initLogger);
var TranslationStatus = (__webpack_require__(44553).TranslationStatus);
var normalizeUrlForCanonical = (__webpack_require__(8339).normalizeUrlForCanonical);
var logger = initLogger();
var MONDAY_BASE_PATH = (/* unused pure expression or super */ null && ("https://monday.com"));
var getTranslatedLanguages = function() {
    var _ref = _async_to_generator(function(paths) {
        var aggregations, translations, e;
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    aggregations = [
                        {
                            $match: {
                                path: {
                                    $in: paths
                                }
                            }
                        },
                        {
                            $group: {
                                _id: "$path",
                                path: {
                                    $first: "$path"
                                },
                                languages: {
                                    $addToSet: {
                                        $concat: [
                                            "$language"
                                        ]
                                    }
                                }
                            }
                        }
                    ];
                    return [
                        4,
                        TranslationJob.aggregate(aggregations)
                    ];
                case 1:
                    translations = _state.sent();
                    return [
                        2,
                        translations
                    ];
                case 2:
                    e = _state.sent();
                    logger.error(e);
                    return [
                        2,
                        []
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getTranslatedLanguages(paths) {
        return _ref.apply(this, arguments);
    };
}();
var updateTranslationJobOnPublish = function() {
    var _ref = _async_to_generator(function(translationJobId) {
        var e;
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        TranslationJob.findByIdAndUpdate(translationJobId, {
                            translationStatus: TranslationStatus.DONE
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    logger.error(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function updateTranslationJobOnPublish(translationJobId) {
        return _ref.apply(this, arguments);
    };
}();
var getPageLocales = function() {
    var _ref = _async_to_generator(function(path) {
        var normalizedPath, currentVersion, currentVersions, locales, result, e;
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    normalizedPath = normalizePath(path);
                    return [
                        4,
                        CurrentPageVersion.findOne({
                            path: normalizedPath
                        }).populate(PAGE_ID_FIELD_NAME)
                    ];
                case 1:
                    currentVersion = _state.sent();
                    if (!currentVersion) return [
                        2,
                        []
                    ];
                    return [
                        4,
                        CurrentPageVersion.aggregate([
                            {
                                $match: {
                                    pageId: currentVersion.pageId._id
                                }
                            },
                            {
                                $project: {
                                    path: "$path",
                                    locale: "$locale"
                                }
                            }
                        ])
                    ];
                case 2:
                    currentVersions = _state.sent();
                    locales = [
                        {
                            path: currentVersion.pageId.path,
                            locale: "x-default"
                        }
                    ].concat(_toConsumableArray(currentVersions));
                    result = locales.map(function(param) {
                        var locale = param.locale, _$path = param.path;
                        return {
                            path: normalizeUrlForCanonical(_$path),
                            locale: locale
                        };
                    });
                    return [
                        2,
                        result
                    ];
                case 3:
                    e = _state.sent();
                    logger.error(e);
                    return [
                        2,
                        []
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getPageLocales(path) {
        return _ref.apply(this, arguments);
    };
}();
module.exports = {
    getTranslatedLanguages: getTranslatedLanguages,
    updateTranslationJobOnPublish: updateTranslationJobOnPublish,
    getPageLocales: getPageLocales
};


/***/ }),

/***/ 35624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ getPricingPageConfig; }
/* harmony export */ });
var getPricingPageConfig = function() {
    return {
        template: "LongTemplate",
        title: "monday.com pricing and plans",
        description: "Starting from $8 per user per month, monday.com’s pricing has a plan for everyone.",
        canonicalUrl: "https://monday.com/pricing/",
        withFullstory: true,
        enableHotjar: true,
        fullstoryRecordingFrequency: 100,
        pricingDefaults: {
            defaultCurrency: "usd",
            defaultBillingPeriod: "yearly",
            defaultSelectedPlanName: "standard"
        },
        topbar: {
            preventMenu: false
        },
        socialButtons: {
            show: false
        },
        customersList: [
            {
                name: "outbrain",
                imgSrc: "/static/img/pricing/outbrain.jpg"
            },
            {
                name: "conduit",
                imgSrc: "/static/img/pricing/conduit.jpg"
            },
            {
                name: "wework",
                imgSrc: "/static/img/pricing/wework.jpg"
            },
            {
                name: "spotim",
                imgSrc: "/static/img/pricing/spotim.jpg"
            }
        ],
        tweetIds: [
            "950446913760956420",
            "948055055302770689",
            "948379472830652416",
            "940538468249333760"
        ]
    };
};


/***/ }),

/***/ 48965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ getOverrideParams; }
/* harmony export */ });
/* harmony import */ var _constants_query_params__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54224);
/* harmony import */ var _constants_query_params__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_constants_query_params__WEBPACK_IMPORTED_MODULE_0__);

var getOverrideParams = function() {
    var queryParams = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var paramsToUse = {};
    _constants_query_params__WEBPACK_IMPORTED_MODULE_0__.SUPPORTED_OVERRIDE_QUERY_PARAMS.forEach(function(key) {
        if (queryParams.hasOwnProperty(key)) {
            paramsToUse[key] = queryParams[key];
        }
    });
    return paramsToUse;
};


/***/ }),

/***/ 90215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Aq": function() { return /* binding */ migrateExistingTranslations; },
/* harmony export */   "Ed": function() { return /* binding */ getPageExists; },
/* harmony export */   "IS": function() { return /* binding */ restorePage; },
/* harmony export */   "OP": function() { return /* binding */ fetchAbTestsData; },
/* harmony export */   "Po": function() { return /* binding */ startAbTest; },
/* harmony export */   "RC": function() { return /* binding */ createAbTest; },
/* harmony export */   "Sz": function() { return /* binding */ getSolutions; },
/* harmony export */   "U$": function() { return /* binding */ fetchTranslatedPages; },
/* harmony export */   "YS": function() { return /* binding */ createTranslationJobs; },
/* harmony export */   "fD": function() { return /* binding */ removePage; },
/* harmony export */   "fx": function() { return /* binding */ getPage; },
/* harmony export */   "r7": function() { return /* binding */ refreshTranslationJobsStatus; },
/* harmony export */   "rK": function() { return /* binding */ getOrCreatePageModel; },
/* harmony export */   "st": function() { return /* binding */ publishPage; },
/* harmony export */   "xK": function() { return /* binding */ stopAbTest; },
/* harmony export */   "zM": function() { return /* binding */ fetchDraftConfig; },
/* harmony export */   "zd": function() { return /* binding */ getClusters; },
/* harmony export */   "zt": function() { return /* binding */ getSolutionById; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10092);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var URL_BASE = "https://monday.com";
var LOCAL_URL_BASE = "http://localhost:5000";
var DEFAULT_FETCH_OPTIONS = {
    credentials: "same-origin",
    headers: {
        "Content-Type": "application/json"
    }
};
var baseFetch = function(url, options) {
    return fetch(url, _object_spread({}, DEFAULT_FETCH_OPTIONS, options));
};
var getPage = function(path, options) {
    var isServer = !true;
    var baseUrl = isServer ? LOCAL_URL_BASE : URL_BASE;
    return baseFetch("".concat(baseUrl, "/get-page-config?path=").concat(path));
};
var getPageExists = function(path, options) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/generated-page-exists?path=").concat(path));
};
var removePage = function(path) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/remove-page?path=").concat(path), {
        method: "POST"
    });
};
var publishPage = function(pageConfig) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/publish"), {
        method: "POST",
        body: JSON.stringify({
            pageConfig: pageConfig
        })
    });
};
var restorePage = function(path, historyIndex) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/restore-page"), {
        method: "POST",
        body: JSON.stringify({
            path: path,
            historyIndex: historyIndex
        })
    });
};
var getOrCreatePageModel = function(path) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/get-or-create-page"), {
        method: "POST",
        body: JSON.stringify({
            path: path
        })
    });
};
var migrateExistingTranslations = function(path) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/migrate-existing-translations"), {
        method: "POST",
        body: JSON.stringify({
            path: path
        })
    });
};
var fetchTranslatedPages = function(filter) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/get-translated-pages?filter=").concat(filter), {
        method: "GET"
    });
};
var createTranslationJobs = function(path, languages, translationStrategy) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/create-translation-jobs"), {
        method: "POST",
        body: JSON.stringify({
            path: path,
            languages: languages,
            translationStrategy: translationStrategy
        })
    });
};
var refreshTranslationJobsStatus = function() {
    var _ref = _async_to_generator(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_0__.__generator)(this, function(_state) {
            return [
                2,
                baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/refresh-translation-jobs-status"), {
                    method: "POST"
                })
            ];
        });
    });
    return function refreshTranslationJobsStatus() {
        return _ref.apply(this, arguments);
    };
}();
var fetchDraftConfig = function(translationJobId) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/get-translation-job/").concat(translationJobId, "/draft-config"), {
        method: "GET"
    });
};
var createAbTest = function(abTestData) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/create-ab-test"), {
        method: "POST",
        body: JSON.stringify({
            abTestData: abTestData
        })
    });
};
var fetchAbTestsData = function() {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/fetch-ab-tests-data"), {
        method: "GET"
    });
};
var startAbTest = function(abTestId) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/start-ab-test"), {
        method: "POST",
        body: JSON.stringify({
            abTestId: abTestId
        })
    });
};
var stopAbTest = function(abTestId) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/stop-ab-test"), {
        method: "POST",
        body: JSON.stringify({
            abTestId: abTestId
        })
    });
};
var getClusters = function() {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/get-clusters"), {
        method: "GET"
    });
};
var getSolutions = function() {
    var _ref = _async_to_generator(function() {
        var res, solutions;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_0__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/get-solutions"), {
                            method: "GET"
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    solutions = _state.sent();
                    return [
                        2,
                        solutions
                    ];
            }
        });
    });
    return function getSolutions() {
        return _ref.apply(this, arguments);
    };
}();
var getSolutionById = function() {
    var _ref = _async_to_generator(function(param) {
        var solutionId, localeId, res, solution;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_0__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    solutionId = param.solutionId, localeId = param.localeId;
                    return [
                        4,
                        baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/get-solution?localeId=").concat(localeId, "&solutionId=").concat(solutionId), {
                            method: "GET"
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    solution = _state.sent();
                    return [
                        2,
                        solution
                    ];
            }
        });
    });
    return function getSolutionById(_) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);